// material-ui
import Box from '@mui/material/Box';

// project imports
import logo from 'assets/images/zoidesq.png';

// ==============================|| Loader — modern branded spinner ||============================== //

export default function Loader() {
  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 2001,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#ffffff',
        '@keyframes zqspin': { to: { transform: 'rotate(360deg)' } },
        '@keyframes zqpulse': {
          '0%, 100%': { transform: 'scale(1)', opacity: 1 },
          '50%': { transform: 'scale(0.9)', opacity: 0.85 },
        },
      }}
    >
      <Box sx={{ position: 'relative', width: 88, height: 88, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {/* rotating gradient ring */}
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            borderRadius: '50%',
            background: 'conic-gradient(from 90deg, #002C84, #01ADFD, #002C84)',
            WebkitMask: 'radial-gradient(farthest-side, transparent calc(100% - 5px), #000 calc(100% - 5px))',
            mask: 'radial-gradient(farthest-side, transparent calc(100% - 5px), #000 calc(100% - 5px))',
            animation: 'zqspin 0.9s linear infinite',
          }}
        />
        {/* logo */}
        <Box
          component="img"
          src={logo}
          alt="Loading"
          sx={{ width: 48, height: 48, objectFit: 'contain', animation: 'zqpulse 1.4s ease-in-out infinite' }}
        />
      </Box>
    </Box>
  );
}
